const TRACK_TIMEOUT_MS = 400;

async function trackClick(productId: string): Promise<void> {
  await fetch("/api/track-click", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product_name: productId }),
  });
}

export async function handleCheckout(productId: string): Promise<void> {
  if (process.env.NODE_ENV === "production") {
    await Promise.race([
      trackClick(productId),
      new Promise<void>((resolve) => setTimeout(resolve, TRACK_TIMEOUT_MS)),
    ]).catch(() => {});
  }

  try {
    const response = await fetch("/api/create-checkout-session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId }),
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error((data as { error?: string }).error || "Failed to create checkout session");
    }

    const { url } = await response.json();
    window.location.href = url;
  } catch (error) {
    console.error("Checkout error:", error);
    alert(
      "결제 페이지를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.\n(Could not open the payment page. Please try again.)"
    );
  }
}
